import styled from "styled-components";
export const StyledTableCell = styled.td `
  min-width: ${({ width }) => (width === "auto" ? width : `${width}px`)};
  font-size: ${({ font }) => (font && font.size) || ""};
  font-weight: ${({ font }) => (font && font.weight) || ""};
  line-height: ${({ font }) => (font && font.lineHeight) || ""};
  padding: 10px 1rem;
  text-align: ${({ align }) => align};
  outline: none;

  div > span svg {
    width: 0.5rem;
    height: 0.5rem;
  }
  label > span svg {
    fill: white;
    width: 1rem;
    height: 1rem;
  }
`;
export const StyledTableHeaderCell = styled.th `
  min-width: ${({ width }) => (width === "auto" ? width : `${width}px`)};
  font-size: ${({ font }) => (font && font.size) || ""};
  font-weight: ${({ font }) => (font && font.weight) || ""};
  line-height: ${({ font }) => (font && font.lineHeight) || ""};
  vertical-align: top;
  outline: none;

  :first-child {
    padding: ${({ tableType }) => (tableType === "TB02" ? "0" : "auto")};
    & span.sort-icon {
      display: ${({ tableType }) => (tableType === "TB02" ? "none" : "auto")};
    }
  }

  padding: 10px 1rem;
  & span.sort-icon {
    ${({ align }) => align === "left" ? " padding-left: 0.5rem;" : "padding-right: 0.5rem;"};
    ${({ theme, sortOrder }) => sortOrder
    ? `color: ${theme.colors.black};`
    : `color: rgb(${theme.colors.transparentBlack}, 0.26); `}
  }
  div > span svg {
    width: 0.5rem;
    height: 0.5rem;
  }
  label > span svg {
    fill: white;
    width: 1rem;
    height: 1rem;
  }
  text-align: ${({ align }) => align};
  cursor: ${({ sortIcon }) => (sortIcon ? "pointer" : "auto")};

  @media (hover: hover) {
    :hover {
      ${({ sortIcon, theme }) => sortIcon
    ? `background-color: rgb(${theme.colors.transparentBlack}, 0.08);cursor: pointer;`
    : ""};
    }
  }

  ${({ focusVisible, theme }) => focusVisible ? `outline: 2px solid ${theme.colors.primaryLight};` : ""};

  :active {
    ${({ sortIcon, theme }) => sortIcon ? `background-color: ${theme.colors.grey15}` : ""};
    ${({ sortIcon, theme }) => sortIcon ? `color: ${theme.colors.white}` : ""};
    span {
      ${({ sortIcon, theme }) => sortIcon ? `color: ${theme.colors.white}` : ""};
    }
    span {
      ${({ sortIcon, theme }) => sortIcon ? `border-bottom-color: ${theme.colors.white}` : ""};
    }
  }

  &.disabled,
  &.disabled:active,
  &.disabled:hover {
    color: ${({ theme }) => `rgb(${theme.colors.transparentBlack}, 0.26);`};
    span {
      color: ${({ theme }) => `rgb(${theme.colors.transparentBlack}, 0.26);`};
    }
    pointer-events: none;
  }

  &.readonly,
  &.readonly:active,
  &.readonly:hover {
    color: ${({ theme }) => `rgb(${theme.colors.transparentBlack}, 0.26);`};
    pointer-events: none;
  }
`;
